import { Grid2 as Grid } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import PageFilter from "../Misc/PageFilter";
import { DbAssetObjectInfos } from "../../Core/Api/Types/db-asset-object-infos";
import { GetMetadataByTagName } from "../../Core/Utils/asset-object-utils";
import { F2Logo, F3Logo, F4Logo, F5Logo, OkooLogo, SlashLogo } from "./adam-logos";

interface AdamChannelsPageFiltersProps {
  rows: DbAssetObjectInfos[];
  filterChannel: string[];
  setFilterChannel: any;
  isSearch?: boolean;
  isLoading?: boolean;
}

const staticChannels = [
  {
    icon: <F2Logo />,
    name: "France 2",
    label: "F2",
    value: "F2",
  },
  {
    icon: <F3Logo />,
    name: "France 3",
    label: "F3",
    value: "F3",
  },
  {
    icon: <F4Logo />,
    name: "France 4",
    label: "F4",
    value: "F4",
  },
  {
    icon: <F5Logo />,
    name: "France 5",
    label: "F5",
    value: "F5",
  },
  {
    icon: <OkooLogo />,
    name: "Okoo F3",
    label: "OKOO F3",
    value: "OKOO_F3",
  },
  {
    icon: <OkooLogo />,
    name: "Okoo F4",
    label: "OKOO F4",
    value: "OKOO_F4",
  },
  {
    icon: <OkooLogo />,
    name: "Okoo F5",
    label: "OKOO F5",
    value: "OKOO_F5",
  },
  {
    icon: "/static/images/adam-logos/ftv-logo.png",
    name: "FTV",
    label: "FTV",
    value: "FG",
  },
  {
    icon: <SlashLogo />,
    name: "Slash",
    label: "SL",
    value: "SL",
  },
  {
    icon: "/static/images/adam-logos/lumni.png",
    name: "Lumni",
    label: "LU",
    value: "LU",
  },
];

const AdamChannelsPageFilters: FC<AdamChannelsPageFiltersProps> = (props) => {
  const { rows, setFilterChannel, filterChannel, isSearch = false, isLoading } = props;
  const [localFilterChannel, setLocalFilterChannel] = useState<string[]>(filterChannel);
  const [firstRender, setFirstRender] = useState<boolean>(true);

  useEffect(() => {
    !firstRender && setFilterChannel(localFilterChannel);
    firstRender && setFirstRender(false);
  }, [localFilterChannel.length]);

  useEffect(() => {
    setLocalFilterChannel(filterChannel);
  }, [filterChannel.length]);

  const channelCounts = useMemo(() => {
    const counts: Record<string, number> = {};

    rows.forEach((x) => {
      const channelValues: string[] = [
        GetMetadataByTagName(x, "rc_ba_lib_chaine")?.value,
        GetMetadataByTagName(x, "source_lib_chaines")?.value,
        GetMetadataByTagName(x, "rc_ba_lib_chaine_enfant")?.value,
      ].flat();

      const channelValuesMapped = channelValues.reduce((acc: string[], val: string) => {
        if (val && !acc.includes(val) && val !== undefined) {
          acc.push(val);
        }
        return acc;
      }, []);

      channelValuesMapped.forEach((chaine) => {
        counts[chaine] = (counts[chaine] || 0) + 1;
      });
    });

    return counts;
  }, [rows]);

  const channels = useMemo(() => {
    return staticChannels.map((channel) => ({
      ...channel,
      count: channelCounts[channel.value] || 0,
    }));
  }, [channelCounts]);

  const handleFilterChange = (channel: string) => {
    setLocalFilterChannel((x) => {
      if (x.includes(channel)) return x.filter((c) => c !== channel);
      else return [...x, channel];
    });
  };

  return (
    <Grid container spacing={1.5} mb={1}>
      {channels.map((x, i) => (
        <Grid key={i} size={{ md: 12 / channels.length, sm: 24 / channels.length, xs: 48 / channels.length }}>
          <PageFilter
            small
            title={isSearch ? x.label : x.count}
            subtitle={isSearch ? "" : x.label}
            onClick={() => handleFilterChange(x.value)}
            active={filterChannel.includes(x.value)}
            icon={x.icon}
            sx={(t) => ({ width: "100%", height: "100%", ".MuiAvatar-root": { background: "#000" } })}
            variant="background"
            isLoading={isLoading}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default AdamChannelsPageFilters;
